module.exports = __webpack_public_path__ + "media/images/emblems/Grossaffoltern-coat_of_arms-32139fd189cfed0c87aece793df9dfdc.svg";